import {defineMessages} from 'react-intl';

const t = defineMessages({
  'shared.navbar.app-title': {
    id: 'shared.navbar.app-title',
    defaultMessage: 'Profile',
  },
  'shared.navbar.my-account': {
    id: 'shared.navbar.my-account',
    defaultMessage: 'My Account',
  },
  'shared.cancel': {
    id: 'shared.cancel',
    defaultMessage: 'Cancel',
  },
  'shared.done': {
    id: 'shared.done',
    defaultMessage: 'Done',
  },
  'shared.save': {
    id: 'shared.save',
    defaultMessage: 'Save',
  },
  'shared.saving': {
    id: 'shared.saving',
    defaultMessage: 'Saving...',
  },
  'shared.edit': {
    id: 'shared.edit',
    defaultMessage: 'Edit',
  },
  'shared.close': {
    id: 'shared.close',
    defaultMessage: 'Close',
  },
  'shared.continue': {
    id: 'shared.continue',
    defaultMessage: 'Continue',
  },
  'shared.none-set': {
    id: 'shared.none-set',
    defaultMessage: 'None set',
  },
  'shared.illegal-character-entry': {
    id: 'shared.illegal-character-entry',
    defaultMessage: 'Enter a value that doesn\'t include <, >, %, &, or brackets.',
  },
  'shared.back': {
    id: 'shared.back',
    defaultMessage: 'Back',
  },
  'shared.confirm': {
    id: 'shared.confirm',
    defaultMessage: 'Confirm',
  },
  'shared.confirming': {
    id: 'shared.confirming',
    defaultMessage: 'Confirming...',
  },
  'shared.help.support': {
    id: 'shared.help.support',
    defaultMessage: 'Support',
  },
  'shared.almost-there': {
    id: 'shared.almost-there',
    defaultMessage: 'Almost There...',
  },
  'shared.connect-to-google': {
    id: 'shared.connect-to-google',
    defaultMessage: 'Connect to Google',
    description: 'Link text for connecting to Google social account',
  },
  'shared.connect-to-facebook': {
    id: 'shared.connect-to-facebook',
    defaultMessage: 'Connect to Facebook',
    description: 'Link text for connecting to Facebook social account',
  },
  'shared.connect-to-linkedin': {
    id: 'shared.connect-to-linkedin',
    defaultMessage: 'Connect to LinkedIn',
    description: 'Link text for connecting to LinkedIn social account',
  },
  'shared.connect-to-microsoft': {
    id: 'shared.connect-to-microsoft',
    defaultMessage: 'Connect to Microsoft',
    description: 'Link text for connecting to Microsoft social account',
  },
  'shared.connect-to-lastpass': {
    id: 'shared.connect-to-lastpass',
    defaultMessage: 'Connect to LastPass',
    description: 'Link text for connecting to LastPass social account',
  },
  'shared.connect-to-apple': {
    id: 'shared.connect-to-apple',
    defaultMessage: 'Connect to Apple',
    description: 'Link text for connecting to Apple social account',
  },
  'shared.or': {
    id: 'shared.or',
    defaultMessage: 'or',
    description: 'Word OR to separate two available actions.',
  },
  'shared.select.prompt': {
    id: 'shared.select.prompt',
    defaultMessage: 'Select...',
    description: 'Used as a prompt text in select dropdown lists to prompt the user to make a selection',
  },
  'shared.personal.info': {
    id: 'shared.personal.info',
    defaultMessage: 'Personal Info',
    description: 'Section title for the personal info fields and navbar link',
  },
});

export default t;
